module.exports = __webpack_public_path__ + "img/curricular_mesh_duoc_logo.935f35fc.png";